<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VQBeg/tc-custom/cover.jpg?1638240505983?1729082730919" alt="This image is the cover for the book Oilfield Processing of Petroleum"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oilfield Processing of Petroleum
      </h1>
      <p class="bookDescription body article font2">
        <p>Covers process descriptions, design method, operating procedures, and troubleshooting in great detail. This text is the definitive source on its topic and contains numerous diagrams and appendices, as well as case histories and review questions with numerical problems.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francis Manning, Richard Thompson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23f926e6